export interface GlobalInitialStateTypes {
	isLoading: boolean;
	uuid: string | null;
}

export const globalInitialState: GlobalInitialStateTypes = {
	isLoading: true,
	uuid: null,
};
